enum TransactionOriginalStatus {
  BOOKED = 'BOOKED',
  RESERVED = 'RESERVED',
  CLEARED = 'CLEARED',
}

export default TransactionOriginalStatus;
